// extracted by mini-css-extract-plugin
export default {"mobile":"Layout_mobile__ZvfjK"};